// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    /* Background Colors */
    --ds-day-bg-color: none;
    --ds-day-disabled-bg-color: none;
    --ds-day-hover-bg-color: var(--ds-color-grey-indigo-50);
    --ds-day-selected-bg-color: var(--ds-color-grey-10);
    --ds-day-selected-hover-bg-color: var(--ds-color-neon-0);
    --ds-day-marked-bg-color: var(--ds-color-grey-20);
    /* Dot Colors */
    --ds-current-day-dot-bg-color: var(--ds-color-neon-0);
    --ds-current-day-dot-selected-bg-color: var(--ds-color-grey-indigo-50);
    --ds-current-day-dot-disabled-bg-color: var(--ds-color-neon-0);
    /* Borders / Outlines */
    --ds-day-focus-outline-color: var(--ds-color-neon-0);
    /* Font related */
    --ds-day-text-color: var(--ds-font-color-accent);
    --ds-day-selected-text-color: var(--ds-color-grey-indigo-50);
    --ds-day-other-month-text-color: var(--ds-color-grey-indigo-30);
    --ds-day-disabled-text-color: var(--ds-color-grey-indigo-40);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
